import api from './api';

const tasksService = {
  // Get all tasks with optional filters
  getTasks: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.status) params.append('status', filters.status);
      if (filters.priority) params.append('priority', filters.priority);
      if (filters.client_id) params.append('client_id', filters.client_id);
      if (filters.overdue_only) params.append('overdue_only', filters.overdue_only);
      if (filters.due_soon) params.append('due_soon', filters.due_soon);

      const queryString = params.toString();
      const url = queryString ? `/tasks?${queryString}` : '/tasks';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching tasks:', error);
      throw error;
    }
  },

  // Get task statistics for dashboard
  getTaskStats: async () => {
    try {
      const response = await api.get('/tasks/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching task statistics:', error);
      throw error;
    }
  },

  // Create a new task
  createTask: async (taskData) => {
    try {
      const response = await api.post('/tasks', taskData);
      return response.data;
    } catch (error) {
      console.error('Error creating task:', error);
      throw error;
    }
  },

  // Update an existing task
  updateTask: async (taskId, updates) => {
    try {
      const response = await api.put(`/tasks/${taskId}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating task:', error);
      throw error;
    }
  },

  // Mark task as completed
  completeTask: async (taskId, notes = null) => {
    try {
      const response = await api.put(`/tasks/${taskId}`, {
        status: 'completed',
        notes: notes
      });
      return response.data;
    } catch (error) {
      console.error('Error completing task:', error);
      throw error;
    }
  },

  // Delete a task
  deleteTask: async (taskId) => {
    try {
      const response = await api.delete(`/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting task:', error);
      throw error;
    }
  },

  // Get tasks for a specific client
  getClientTasks: async (clientId) => {
    try {
      const response = await api.get(`/tasks?client_id=${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching client tasks:', error);
      throw error;
    }
  },

  // Get overdue tasks
  getOverdueTasks: async () => {
    try {
      const response = await api.get('/tasks?overdue_only=true');
      return response.data;
    } catch (error) {
      console.error('Error fetching overdue tasks:', error);
      throw error;
    }
  },

  // Get tasks due soon (within 24 hours)
  getDueSoonTasks: async () => {
    try {
      const response = await api.get('/tasks?due_soon=true');
      return response.data;
    } catch (error) {
      console.error('Error fetching due soon tasks:', error);
      throw error;
    }
  },

  // Task Templates Management
  getTaskTemplates: async (workflowStageId = null) => {
    try {
      const params = new URLSearchParams();
      if (workflowStageId) params.append('workflow_stage_id', workflowStageId);
      
      const queryString = params.toString();
      const url = queryString ? `/tasks/templates?${queryString}` : '/tasks/templates';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching task templates:', error);
      throw error;
    }
  },

  createTaskTemplate: async (templateData) => {
    try {
      const response = await api.post('/tasks/templates', templateData);
      return response.data;
    } catch (error) {
      console.error('Error creating task template:', error);
      throw error;
    }
  },

  updateTaskTemplate: async (templateId, updates) => {
    try {
      const response = await api.put(`/tasks/templates/${templateId}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating task template:', error);
      throw error;
    }
  },

  deleteTaskTemplate: async (templateId) => {
    try {
      const response = await api.delete(`/tasks/templates/${templateId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting task template:', error);
      throw error;
    }
  },

  assignTemplateToStage: async (templateId, stageId) => {
    try {
      const response = await api.post(`/tasks/templates/${templateId}/assign-stage`, {
        workflow_stage_id: stageId
      });
      return response.data;
    } catch (error) {
      console.error('Error assigning template to stage:', error);
      throw error;
    }
  },

  unassignTemplateFromStage: async (templateId, stageId) => {
    try {
      const response = await api.delete(`/tasks/templates/${templateId}/unassign-stage/${stageId}`);
      return response.data;
    } catch (error) {
      console.error('Error unassigning template from stage:', error);
      throw error;
    }
  }
};

export default tasksService;